import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jhi-error',
    templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
    errorMessage: string;
    successMessage: string;
    error403: boolean;
    error404: boolean;
    error500: boolean;
    title: string;
    state: any;
    private subscription: Subscription;

    constructor(private route: ActivatedRoute, private translateService: TranslateService, private router: Router) {
        this.state = this.router.getCurrentNavigation().extras.state;
    }

    ngOnInit() {
        this.subscription = this.route.data.subscribe(routeData => {
            if (routeData.error403) {
                this.error403 = routeData.error403;
                this.title = routeData.pageTitle;
                this.errorMessage = this.translateService.instant('spans.error.message.403');
            }
            if (routeData.error404) {
                this.error404 = routeData.error404;
                this.title = routeData.pageTitle;
                this.errorMessage = this.translateService.instant('spans.error.message.404');
            }
            if (routeData.error500) {
                this.error500 = routeData.error500;
                this.title = routeData.pageTitle;
                this.errorMessage = this.translateService.instant('spans.error.message.500', { error: this.state.detail });
            }
        });
    }

    redirectToHomepage() {
        this.router.navigate(['/']);
    }

    ngOnDestroy() {
        if(this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
